import React, {useState} from 'react'
import { Nav, NavbarContainer, NavLogo, NavItem, NavIcon, MobileIcon, NavLinks, NavMenu, ExternalLink } from './NavbarElements'
import { FaBars, FaCaretDown } from 'react-icons/fa'
import  image from '../../images/ATENIDA-2-NOWE-03.png'
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
// import Dropdown from '../Dropdown/Dropdown';
import Dropdown2 from '../Dropdown2/Dropdown2';
import { useLocation } from 'react-router-dom';
import { RequireAdminComp } from '../RequireAuth'


const Navbar = ({ toggle }) => {
    const location = useLocation();

    const toggleHome = () => { scroll.scrollTo(0, { smooth: true, duration: 600 }); };

    const [dropdown, setDropdown] = useState(false);
    const [dropdown2, setDropdown2] = useState(false);
    const { route, signOut } = useAuthenticator((context) => [
        context.route,
        context.signOut,
      ]);
      const navigate = useNavigate();
    
      function logOut() {
        signOut();
        navigate('/');
      }

    const onMouseEnter2 = () => {
        if(window.innerWidth <960){
            setDropdown2(false);
        } else {
            setDropdown2(true);
        }
    }

    const onMouseLeave2 = () => {
        if(window.innerWidth <960){
            setDropdown2(false);
        } else {
            setDropdown2(false);
        }
    }
    const { pathname } = useLocation();
  return (
    <>
        <Nav>
            <NavbarContainer>
                <NavLogo to='/' onClick={toggleHome}><NavIcon src={image} /></NavLogo>
                <MobileIcon onClick={toggle}>
                    <FaBars />
                </MobileIcon>
                <NavMenu>

                    <NavItem>
                        <NavLinks to='/ceremonie' onClick={toggleHome} className={pathname === "/ceremonie" ? "active" : ""}>Ceremonie</NavLinks>
                    </NavItem>
                    <NavItem
                    onClick={(e) => {
                        const href = e.target.getAttribute("href") || "";
                        // jeśli link prowadzi do #sekcji (na tej samej stronie), NIE przewijaj na górę
                        if (!href.includes("#")) {
                        toggleHome();
                        }
                    }}
                    onMouseEnter={onMouseEnter2}
                    onMouseLeave={onMouseLeave2}
                    className={(pathname === "/pakiety" || pathname === "/wsparcie" || pathname === "/konsultacje" || pathname === "/edukacja" || pathname === "/bizuteria") ? "active" : ""}
                    >
                        <NavLinks>Oferta <FaCaretDown /></NavLinks>
                        {dropdown2 && <Dropdown2 />
                        
                        }
                    </NavItem>
                                        <NavItem>
                    <ExternalLink
                        href="https://sklep.atenida.pl"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Sklep
                    </ExternalLink>
                    </NavItem>
                    <NavItem>
                        <NavLinks to='/news' onClick={toggleHome} className={pathname === "/news" ? "active" : ""}>Inspiracje</NavLinks>
                    </NavItem>
                    <NavItem>
                        <NavLinks to='/faq' onClick={toggleHome} className={pathname === "/faq" ? "active" : ""}>FAQ</NavLinks>
                    </NavItem>
                    <NavItem>
                        <NavLinks to='/omnie' onClick={toggleHome} className={pathname === "/omnie" ? "active" : ""}>O mnie</NavLinks>
                    </NavItem>
                    <NavItem>
                        <NavLinks to='/kontakt' onClick={toggleHome} className={pathname === "/kontakt" ? "active" : ""}>Kontakt</NavLinks>
                    </NavItem>

                    <NavItem>
                        {route === 'authenticated' ? (
                        <NavLinks to='/' onClick={() => logOut()}>Wyloguj</NavLinks>)
                        : (<NavLinks to='/login'>Zaloguj</NavLinks>)}
                    </NavItem>
                    <RequireAdminComp>
                    <NavItem>
                        <NavLinks to='/adminpage' onClick={toggleHome} className={pathname === "/adminpage" ? "active" : ""}>Admin</NavLinks>
                    </NavItem>
                    </RequireAdminComp>
                </NavMenu>
            </NavbarContainer>
        </Nav>
    </>
  )
}

export default Navbar